import React from 'react';

/**
 * Progress bar component for the start flow
 */
const ProgressBar = ({ currentStep = 1 }) => {
  const steps = [
    { number: 1, label: 'Select Times' },
    { number: 2, label: 'Your Info' },
    { number: 3, label: 'Done' }
  ];

  return (
    <div className="w-full max-w-2xl mx-auto mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            {/* Step */}
            <div className="flex flex-col items-center">
              <div className="text-sm text-gray-400 mb-2">
                Step {step.number}: {step.label}
              </div>
              <div className={`w-4 h-4 rounded-full flex items-center justify-center ${
                currentStep >= step.number 
                  ? 'bg-purple-500 text-white' 
                  : 'bg-gray-600 text-gray-400'
              }`}>
                {currentStep >= step.number ? '●' : '○'}
              </div>
            </div>
            
            {/* Connector line (don't show after last step) */}
            {index < steps.length - 1 && (
              <div className={`flex-1 h-0.5 mx-4 ${
                currentStep > step.number 
                  ? 'bg-purple-500' 
                  : 'bg-gray-600'
              }`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;